<template>
  <div class="ts-capture_content_container ts-signup-portal">
    <header class="center">
      <h4>Your plan</h4>
    </header>
    <div class="ts-signup-portal-container">
      <header v-if="paymentLoading">
        <h4>Processing payment.</h4>
        <vue-loading
          type="spin"
          color="#5028b7"
          :size="{ width: '50px', height: '50px' }"
        ></vue-loading>
      </header>

      <el-alert
        v-if="paymentError"
        :title="paymentError"
        type="error"
      ></el-alert>

      <el-card class="mb30 pricing_header" v-show="!paymentLoading">
        <span class="pricing_price">Early Bird <strong>$1,000</strong></span>
        <div class="card">
          <card
            class="stripe-card"
            :stripe="stripeKey"
            :options="stripeOptions"
            @change="complete = $event.complete"
          />
        </div>
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          v-on:click="pay()"
        >
          <v-icon name="lock"></v-icon>Pay $1,000
        </button>
        <p class="small">
          By proceeding, you agree to our
          <el-button type="text" small @click="termsDialog = true"
            >terms and conditions</el-button
          >.
        </p>
      </el-card>
    </div>

    <el-dialog title :visible.sync="termsDialog" width="40%">
      <h4>Terms and Conditions</h4>
      <p>
        <a href="/static/terms_conditions.pdf" download
          >Click here to download our Terms & Conditions</a
        >
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { Card, createToken } from "vue-stripe-elements-plus";
import { VueLoading } from "vue-loading-template";

export default {
  created() {
    if (this.currentRegistration.payment == null) {
      this.currentRegistration.payment = {};
    }

    if (this.currentRegistration.Error) {
      this.paymentError = this.currentRegistration.error;
      this.currentRegistration.error = null;
    }
  },
  data() {
    return {
      paymentLoading: false,
      paymentError: null,
      stripeOptions: {},
      modelState: {},
      termsDialog: false,
    };
  },
  components: { Card, VueLoading },
  methods: {
    pay() {
      this.paymentLoading = true;
      createToken()
        .then((res) => {
          if (!res.error) {
            this.currentRegistration.payment.paymentToken = res.token.id;
            this.storeSection();
          } else {
            this.paymentError = res.error.message;
          }
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    },
    storeSection() {
      this.isLoading = true;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then(() => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.modelState = res.errors;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  computed: {
    stripeKey() {
      return process.env.VUE_APP_STRIPE_PK;
    },
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
};
</script>

<style lang="scss"></style>
